export default {
  // 次數包價格字尾
  'pages.voiceClone.packPriceSimple': '（{quota} 次 / ¥{price}）',
  'pages.voiceClone.packPricePrefix': '（{quota} 次 / ',
  'pages.voiceClone.packPriceOriginal': '原價 ¥{price}',
  'pages.voiceClone.packPriceDiscount': '活動優惠 ¥{price}',
  'pages.voiceClone.packPricePaid': '實付 ¥{price}',
  'pages.voiceClone.packPriceClose': '）',

  // 購買須知
  'pages.voiceClone.purchaseNoticeTitle': '購買須知',
  'pages.voiceClone.purchaseNoticeEffectiveDate': '2026年5月30日',
  'pages.voiceClone.purchaseNoticeEffective': '版本生效日期：{date}',
  'pages.voiceClone.purchaseNoticeGreeting':
    '尊敬的使用者，感謝您選擇「{platformName}」聲音復刻服務。請在完成支付前仔細閱讀以下條款：',
  'pages.voiceClone.purchaseNoticeSupplement':
    '本須知作為《使用者協議》的補充，與《使用者協議》及聲音復刻服務頁面展示內容共同構成完整約定；未盡事宜以《使用者協議》及服務頁面為準。',
  'pages.voiceClone.purchaseNoticeSec1Title': '1. 服務權益',
  'pages.voiceClone.purchaseNoticeSec1Intro':
    '您購買的聲音復刻服務，可用於克隆本人聲音，或上傳您已依法取得授權的他人聲音樣本。核心權益包括：',
  'pages.voiceClone.purchaseNoticeSec1Item1':
    '（1）服務期為 1 年，自您支付成功當日起算；您須在上述期限內使用本訂單所含的克隆次數。若單個音色在過去 1 年內未被用於任何語音合成請求，音色克隆提供商將自動刪除該音色導致到期後不能正常合成',
  'pages.voiceClone.purchaseNoticeSec1Item2':
    '（2）同一「{platformName}」賬號下，已復刻音色在同一時間可繫結使用的裝置數量不超過 5 臺。',
  'pages.voiceClone.purchaseNoticeSec1Item3':
    '（3）同一「{platformName}」下單成功後相應訂單7日內未使用過克隆次數的可以申請退款，超過或者已使用過不支援退款。',
  'pages.voiceClone.purchaseNoticeSec2Title': '2. 合法使用',
  'pages.voiceClone.purchaseNoticeSec2Body':
    '您理解並同意：本服務與您的賬號及資訊保安相關，您購買的服務僅限本人賬號按平臺規則使用；未經書面許可，不得以轉讓、出租、出售或其他方式向第三方提供或授權使用。',
  'pages.voiceClone.purchaseNoticeSec3Title': '3. 聯絡我們',
  'pages.voiceClone.purchaseNoticeSec3Body':
    '若您對以上條款或服務有疑問，或存在特殊使用場景，請透過《使用者協議》或應用內公示的客服渠道與我們聯絡。',
  'pages.voiceClone.purchaseNoticeAgree': '我已認真閱讀並理解上述購買須知',
  'pages.voiceClone.agreeAndPay': '同意並繼續支付',

  // 次數包訂單
  'pages.voiceClone.orderLoadFailed': '載入訂單失敗',
  'pages.voiceClone.orderDetailLoadFailed': '載入詳情失敗',
  'pages.voiceClone.refundSubmitted': '已提交退款申請',
  'pages.voiceClone.refundFailed': '退款失敗',
  'pages.voiceClone.orderCanceled': '已取消待支付訂單',
  'pages.voiceClone.orderCancelFailed': '取消失敗',
  'pages.voiceClone.colOrderNo': '訂單號',
  'pages.voiceClone.colAmountYuan': '金額(元)',
  'pages.voiceClone.colQuotaPack': '次數包',
  'pages.voiceClone.quotaRemainingOfTotal': '餘 {remaining}/{total}',
  'pages.voiceClone.colStatus': '狀態',
  'pages.voiceClone.detailAction': '詳情',
  'pages.voiceClone.refundConfirmTitle': '確認申請原路退款？',
  'pages.voiceClone.refundConfirmContentUnused':
    '該次數包尚未用於克隆，退款成功後對應次數包配額將失效，款項按微信支付原路退回。',
  'pages.voiceClone.refundConfirmContentFailed':
    '該訂單為失敗單且次數未被消耗，確認發起微信原路退款？款項將按原支付路徑退回。',
  'pages.voiceClone.refundConfirmOk': '確認退款',
  'pages.voiceClone.refundAction': '申請原路退款',
  'pages.voiceClone.refundNotAllowedTipUsed': '該次數包已有克隆消耗，不支援微信原路退款',
  'pages.voiceClone.refundNotAllowed': '不可退款',
  'pages.voiceClone.refundNotAllowedTipExpired': '已超過支付成功後 7 日內未使用原路退款期限，或款項已退',
  'pages.voiceClone.filterStatusAll': '全部',
  'pages.voiceClone.statusPending': '待支付',
  'pages.voiceClone.statusPaid': '已支付',
  'pages.voiceClone.statusCompleted': '已完成',
  'pages.voiceClone.statusFailed': '失敗',
  'pages.voiceClone.statusCanceled': '已取消',
  'pages.voiceClone.filterOrderNoPlaceholder': '訂單號（模糊）',
  'pages.voiceClone.queryAction': '查詢',
  'pages.voiceClone.orderDetailTitle': '訂單詳情',
  'pages.voiceClone.detailWechatTradeNo': '微信交易號',
  'pages.voiceClone.detailFailedReason': '失敗原因',
  'pages.voiceClone.detailRefundStatus': '退款狀態',
  'pages.voiceClone.quotaSummary': '共 {total}，已用 {used}，剩餘 {remaining}',
  'pages.voiceClone.unusedRefundDeadline': '未使用原路退款截止：{date}',

  // 主頁面通用
  'pages.voiceClone.defaultRefText':
    '清晨的陽光灑進窗臺，新的一天開始了。無論昨天經歷了什麼，今天都是嶄新的機會。保持微笑，用心感受生活的每一個瞬間，你會發現美好其實就在身邊。',
  'pages.voiceClone.platformNameFallback': '本平臺',
  'pages.voiceClone.renameAction': '修改名稱',
  'pages.voiceClone.usageAlertTitle': '音色克隆使用提示',
  'pages.voiceClone.usageAlertDesc1':
    '上傳僅支援 <b>WAV</b>，單檔案不超過 <b>{mb}MB</b>；用於復刻的選區時長鬚在 <b>{min}～{max} 秒</b>。單人朗讀、發音清晰，儘量避免明顯沙啞嗓、氣音與房間回聲。',
  'pages.voiceClone.usageAlertDesc2':
    '克隆訓練<b>成功並完成入庫</b>後，方可在智慧體維護頁的<b>角色音色</b>中選擇使用。',
  'pages.voiceClone.buyPackTitle': '購買音色克隆次數',
  'pages.voiceClone.orderNoLabel': '訂單號：{orderNo}',
  'pages.voiceClone.payScanTip': '請使用微信掃碼支付；支付成功後次數自動到賬。',
  'pages.voiceClone.payQuotaPerPurchase': ' 單次購買含 {quota} 次克隆。',
  'pages.voiceClone.remainingQuota': '剩餘克隆次數：',
  'pages.voiceClone.buyPackHint': '可購買次數包擴充套件配額',
  'pages.voiceClone.buyPackButton': '購買克隆次數包',
  'pages.voiceClone.renameModalTitle': '修改克隆音色名稱',
  'pages.voiceClone.renameRequired': '請輸入名稱',
  'pages.voiceClone.renameMax': '最多 30 個字元',
  'pages.voiceClone.renamePlaceholder': '在角色音色列表中顯示的名稱',

  // 語言下拉展示
  'pages.voiceClone.lang.mandarin': '普通話',
  'pages.voiceClone.lang.cantonese': '粵語',
  'pages.voiceClone.lang.english': '英語',
  'pages.voiceClone.lang.japanese': '日語',
  'pages.voiceClone.lang.korean': '韓語',
  'pages.voiceClone.lang.french': '法語',
  'pages.voiceClone.lang.german': '德語',
  'pages.voiceClone.lang.spanish': '西班牙語',
  'pages.voiceClone.lang.portuguese': '葡萄牙語',
  'pages.voiceClone.lang.russian': '俄語',
  'pages.voiceClone.lang.italian': '義大利語',
  'pages.voiceClone.lang.arabic': '阿拉伯語',
  'pages.voiceClone.lang.turkish': '土耳其語',
  'pages.voiceClone.lang.polish': '波蘭語',
  'pages.voiceClone.lang.catalan': '加泰羅尼亞語',

  // 表單校驗與錄音/上傳互動
  'pages.voiceClone.fieldRefTextHintMinimax':
    '請按此文案朗讀錄製；平臺存檔用，預設不向 MiniMax 傳送 ASR 逐字校驗',
  'pages.voiceClone.aliasMaxRule': '最多 30 個字元（與伺服器校驗一致）',
  'pages.voiceClone.languageRequired': '請選擇語言',
  'pages.voiceClone.refTextRequired': '請填寫參考文字',
  'pages.voiceClone.refTextTooLong': '參考文字過長',
  'pages.voiceClone.providerRequired': '請選擇 TTS 提供商',
  'pages.voiceClone.fieldProviderHint':
    '請選擇已接入聲音克隆的 TTS；克隆音色需與智慧體使用同一提供商型別才能合成',
  'pages.voiceClone.noCloneProvider': '暫無已實現克隆的 TTS，請先在系統配置中新增並啟用',
  'pages.voiceClone.fieldMode': '模式',
  'pages.voiceClone.modeRecord': '錄音',
  'pages.voiceClone.modeUpload': '上傳檔案',
  'pages.voiceClone.recordLabel': '錄音',
  'pages.voiceClone.uploadLabel': '上傳',
  'pages.voiceClone.recordStop': '點選停止錄音',
  'pages.voiceClone.recordStart': '點選開始錄音',
  'pages.voiceClone.recordElapsed': '已錄 {sec} 秒（建議 {minSec}～{maxSec} 秒）',
  'pages.voiceClone.recordDebugHint':
    "排查：確認麥克風未靜音、Chrome 已允許本站麥克風、頁面為 HTTPS；避免選成「立體聲混音」等環回輸入。技術聯調請在控制檯執行 localStorage.setItem('voiceCloneMicDebug','1') 後重新整理再錄，檢視以 [voiceclone-mic] 開頭的日誌。",
  'pages.voiceClone.confirmAudioTooltip':
    '請先錄音或上傳 WAV，在下方確認面板中試聽選區並點選「確認音訊」',
  'pages.voiceClone.clipConfirmed': '已確認用於上傳的片段，可繼續試聽或重新裁剪/更換音源',
  'pages.voiceClone.confirmedClipTitle': '已確認片段',
  'pages.voiceClone.confirmedClipDesc':
    '以下為將隨「上傳樣本」提交的裁剪後 WAV，可試聽核對；仍可修改參考文字、名稱等表單內容。',
  'pages.voiceClone.reclip': '重新裁剪',
  'pages.voiceClone.rerecord': '重新錄音 / 重新選檔案',
  'pages.voiceClone.renameSuccess': '名稱已更新',
  'pages.voiceClone.renameFailed': '更新失敗',

  // 提示與錯誤
  'pages.voiceClone.errRecordingEmpty': '錄音資料為空，請多錄幾秒再停止',
  'pages.voiceClone.errNoValidWaveform': '未檢測到有效聲波，請對著麥克風說話或檢查瀏覽器是否選對錄音裝置',
  'pages.voiceClone.errCheckQuotaFailed': '無法校驗克隆次數',
  'pages.voiceClone.warnQuotaInsufficient': '克隆次數不足，請先購買次數包後再試',
  'pages.voiceClone.createOrderFailed': '建立訂單失敗',
  'pages.voiceClone.errNoPayQr': '未獲取到支付二維碼，請確認服務端已配置微信 Native 支付',
  'pages.voiceClone.paySuccess': '支付成功，克隆次數已到賬',
  'pages.voiceClone.placeOrderFailed': '下單失敗',
  'pages.voiceClone.errMicAccess': '無法訪問麥克風，請檢查瀏覽器許可權與裝置',
  'pages.voiceClone.warnStereoMix':
    '當前為「立體聲混音」等環回裝置，不是麥克風：無系統播放時常常採不到有效聲音。人聲克隆請在系統/瀏覽器裡改選真實麥克風。',
  'pages.voiceClone.warnMicMuted': '檢測到麥克風聲軌為靜音，請在系統混音器或瀏覽器標籤頁中取消靜音後再錄。',
  'pages.voiceClone.errNoAudioRetry': '未採集到音訊資料，請重試並稍長再停止錄音',
  'pages.voiceClone.recordMinDuration': '錄音時長鬚不少於 {minSec} 秒，請重新錄製',
  'pages.voiceClone.errRecordProcessFailed': '錄音處理失敗，請改用「上傳 wav」或重試',
  'pages.voiceClone.errNoAudioStereoMix':
    '未採集到音訊：當前為「立體聲混音」等環回輸入，不是麥克風；無桌面/揚聲器播放時常無任何樣本。請在 Windows「設定 → 系統 → 聲音 → 輸入」或 Chrome 位址列麥克風許可權中改選真實麥克風後再錄。',
  'pages.voiceClone.errNoAudioSamples': '未採集到音訊資料，請多錄幾秒再停止；若仍失敗請換用「上傳 wav」。',
  'pages.voiceClone.errConfirmAudioFirst': '請先完成音訊確認：在確認面板中試聽選區並點選「確認音訊」',
  'pages.voiceClone.uploadVoiceSampleFailed': '上傳聲音樣本失敗',
  'pages.voiceClone.errOnlyWav': '僅支援 WAV 格式',
  'pages.voiceClone.errFileTooLarge': '檔案大小不能超過 {mb}MB',
  'pages.voiceClone.errInvalidWavHeader': '請選擇有效的 WAV 檔案（RIFF/WAVE 頭）',
  'pages.voiceClone.errAudioMinDuration': '音訊時長鬚不少於 {minSec} 秒',
  'pages.voiceClone.errParseWavFailed': '無法解析該 WAV 檔案',
  'pages.voiceClone.errMissingSampleId': '缺少樣本 ID，請返回第 1 步重新上傳',
  'pages.voiceClone.warnNoMasterAudio': '無整段原始音訊，請重新錄音或選擇檔案',

  // 音訊確認面板（VoiceCloneAudioReview）
  'pages.voiceClone.review.durationTooShort': '有效音訊時長鬚不少於 {minSec} 秒，請重新錄製或更換檔案',
  'pages.voiceClone.review.parseWavFailed': '無法解析該 WAV，請檢查檔案是否損壞',
  'pages.voiceClone.review.audioNotReady': '音訊尚未就緒，請稍候再試',
  'pages.voiceClone.review.adjustSelection': '請調整選區，使時長在 {minSec}～{maxSec} 秒之間',
  'pages.voiceClone.review.selectionInvalid': '選區無效，請重新拖動滑塊',
  'pages.voiceClone.review.decodePlayFailed': '無法解碼或播放該片段，請嘗試縮短選區或更換瀏覽器',
  'pages.voiceClone.review.playFailed': '無法播放，請檢查瀏覽器是否允許音訊播放',
  'pages.voiceClone.review.selectionSpanRule': '選區時長鬚為 {minSec}～{maxSec} 秒',
  'pages.voiceClone.review.trimmedTooLarge': '裁剪後 WAV 超過 {maxMb}MB，請縮短選區',
  'pages.voiceClone.review.parsingAudio': '解析音訊…',
  'pages.voiceClone.review.title': '音訊確認',
  'pages.voiceClone.review.tip':
    '試聽整段中的選中部分；拖動兩端豎塊調整起止時間。選區時長鬚在 {minSec}～{maxSec} 秒。不滿意可點「重置」重新錄製或上傳。',
  'pages.voiceClone.review.selectionSpan': '選區時長：{span} s',
  'pages.voiceClone.review.selectionSpanNeed': '（需 {minSec}～{maxSec} s）',
  'pages.voiceClone.review.playSelection': '播放選區',
  'pages.voiceClone.review.confirmAudio': '確認音訊',
  'pages.voiceClone.review.reset': '重置',

  // 錄音建議（VoiceCloneRecordingTips）
  'pages.voiceClone.tips.collapseLabel': '錄音建議',
  'pages.voiceClone.tips.intro': '高質量的輸入音訊是獲得優質復刻效果的基礎。',
  'pages.voiceClone.tips.deviceTitle': '錄音裝置',
  'pages.voiceClone.tips.deviceText':
    '可使用手機、數字錄音筆、專業錄音機等。建議使用支援高取樣率（≥ 24 kHz）錄音的裝置，以滿足音訊要求。',
  'pages.voiceClone.tips.envTitle': '錄音環境',
  'pages.voiceClone.tips.venueLabel': '場地',
  'pages.voiceClone.tips.venue1': '建議在 10 平方米以內的小型封閉空間錄音。',
  'pages.voiceClone.tips.venue2': '優先選擇配有吸音材料（如吸音棉、地毯、窗簾）的房間。',
  'pages.voiceClone.tips.venue3': '避免空曠大廳、會議室、教室等高混響場所。',
  'pages.voiceClone.tips.noiseLabel': '噪音控制',
  'pages.voiceClone.tips.noiseOutdoorLabel': '室外噪音：',
  'pages.voiceClone.tips.noiseOutdoorText': '關閉門窗，避免交通、施工等干擾。',
  'pages.voiceClone.tips.noiseIndoorLabel': '室內噪音：',
  'pages.voiceClone.tips.noiseIndoorText':
    '關閉空調、風扇、日光燈鎮流器等裝置；可透過手機錄製環境音並放大播放，識別潛在噪音源。',
  'pages.voiceClone.tips.reverbLabel': '混響控制',
  'pages.voiceClone.tips.reverb1': '混響會導致聲音模糊、清晰度下降。',
  'pages.voiceClone.tips.reverb2': '減少光滑表面反射：拉上窗簾、開啟衣櫃門、鋪放衣物或床單覆蓋桌面/櫃面。',
  'pages.voiceClone.tips.reverb3': '利用不規則物體（如書架、軟包傢俱）實現聲波漫反射。',
  'pages.voiceClone.tips.scriptTitle': '錄音文案',
  'pages.voiceClone.tips.script1': '內容無特殊限制，建議與目標應用場景一致。',
  'pages.voiceClone.tips.script2': '避免短句（如「你好」、「是的」），應使用完整句子。',
  'pages.voiceClone.tips.script3': '保持語義連貫，朗讀時避免頻繁停頓（建議至少連續 3 秒無中斷）。',
  'pages.voiceClone.tips.script4': '錄音全程保持一致的語速，避免開頭或結尾語速過快導致合成時出現卡頓。',
  'pages.voiceClone.tips.script5': '可加入適當情緒表達（如溫暖、親切、嚴肅），避免機械朗讀。',
  'pages.voiceClone.tips.script6': '不包含敏感詞彙（如政治、色情、暴力相關內容），否則會導致復刻失敗。',
  'pages.voiceClone.tips.opTitle': '操作建議',
  'pages.voiceClone.tips.opIntro': '以普通臥室為例，完成降噪和混響控制後：',
  'pages.voiceClone.tips.op1': '提前熟悉文案，設定角色語氣，自然演繹。',
  'pages.voiceClone.tips.op2': '與錄音裝置保持約 10 釐米距離，避免噴麥或訊號過弱。',
};
